import * as React from "react";
import DataTableFilter from "components/common/DataTable/Filter";
const Filter = ({ setFilteredRows, resetPagination, rows, ...filterProps }) => {
  const onDataFiltered = (newFilteredGroups, filterText) => {
    if (filterText && filterText !== "") {
      setFilteredRows(newFilteredGroups);
    } else {
      setFilteredRows(rows);
    }
    resetPagination();
  };
  return /* @__PURE__ */ React.createElement(DataTableFilter, { ...filterProps, rows, onDataFiltered });
};
export default Filter;
